import videojs from "video.js";
import "./sticker.js";

class PromoSticker extends videojs.getPlugin("plugin") {
  constructor(player, options) {
    super(player);

    player.on('ready', () => {
      this.checkImageSrc(player, options);
    });
  }

  checkImageSrc(player, options) {
    const img = new Image();

    img.onload = function() {
      player.addClass('vjs-sticker');
      player.addChild('Sticker', options);
    };

    img.src = options.stickerUrl;
  }

}

videojs.registerPlugin('promoSticker', PromoSticker);